module.exports = __webpack_public_path__ + "static/img/gpt35.ff4157a6.png";